<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="$v.form.description.$model"
          :errorMessages="getValidationErrorText($v.form.description)"
          label="Описание"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AttachDocumentSingle
          :value="{
            file: $v.form.file.$model,
            fileSig: $v.form.fileSig.$model,
          }"
          :error-messages="getValidationErrorText($v.form.file)"
          @change="
            $v.form.file.$model = $event.file;
            $v.form.fileSig.$model = $event.fileSig;
          "
          disabled-sign
          disabled-sig-name-validation
          :accept-file="['.xml']"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import { maxLength, required } from 'vuelidate/lib/validators';
import { EMOJI, getValidationErrorText } from '@/utils/validate';
import { isNotEmptyObjectCheck } from '@/utils/common';
import { DocumentType } from '@/types/services';

const getDefaultForm = () => ({
  type: DocumentType.MRP,
  description: '',
  file: null,
  fileSig: null,
});

export default {
  name: 'MrpForm',
  components: { AttachDocumentSingle },
  validations() {
    return {
      form: {
        type: {},
        description: {
          maxLength: maxLength(1000),
          EMOJI,
        },
        file: {
          required,
        },
        fileSig: {
          required,
        },
      },
    };
  },
  data: () => ({
    getValidationErrorText,
    type: DocumentType.MRP,
    form: getDefaultForm(),
  }),
  props: {
    document: {
      type: Object,
    },
  },
  created() {
    this.reset();

    if (isNotEmptyObjectCheck(this.document)) {
      this.form = this.document;
    }
  },
  methods: {
    async upload() {
      this.$v.form.$touch();

      return this.$v.form.$invalid ? null : this.form;
    },
    reset() {
      this.form = getDefaultForm();
      this.$v.$reset();
    },
  },
};
</script>

<style scoped></style>
